import type { UseFormReturn } from "react-hook-form";

import type { CareerIntentFormValues, CareerIntentStepId } from "./careerIntentForm";
import CareerGoalsQuestionField from "./_CareerGoalsQuestionField";

export const CAREER_GOALS_FORM_ID = "career-goals-form";

export default function CareerGoalsForm({
  currentRole,
  disabled = false,
  errorMessage,
  form,
  step,
  stepTitle
}: {
  currentRole?: string | null;
  disabled?: boolean;
  errorMessage?: string;
  form: UseFormReturn<CareerIntentFormValues>;
  step: CareerIntentStepId;
  stepTitle: string;
}) {
  const values = form.watch();

  return (
    <form
      id={CAREER_GOALS_FORM_ID}
      className="flex flex-col gap-6"
      data-testid="career-goals-form"
      onSubmit={(event) => event.preventDefault()}
    >
      <h2 className="text-headline-small" data-testid="career-goals-step-title">
        {stepTitle}
      </h2>
      <CareerGoalsQuestionField
        currentRole={currentRole}
        disabled={disabled}
        errorMessage={errorMessage}
        onChange={(nextValues) => {
          (Object.keys(nextValues) as (keyof CareerIntentFormValues)[]).forEach((key) => {
            form.setValue(key, nextValues[key], { shouldDirty: true });
          });
        }}
        step={step}
        values={values}
      />
    </form>
  );
}
